<script setup>
import DashboardLayout from '@/Layouts/DashboardLayout.vue'
import { Head, Link } from '@inertiajs/vue3'

defineProps({
  auth: Object
})
</script>

<template>
  <Head title="Dashboard" />
  
  <DashboardLayout>
    <div class="p-8">
      <div class="mb-8">
        <h1 class="text-2xl font-bold text-gray-900">Dashboard SS</h1>
        <p class="text-gray-500">Welcome back, {{ $page.props.auth.user.name }}!</p>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
        <div class="bg-white p-6 rounded-2xl shadow-sm border border-gray-100">
          <h3 class="text-gray-500 text-sm font-medium mb-2">Active Subscriptions</h3>
          <p class="text-3xl font-bold text-gray-900">0</p>
        </div>
        <div class="bg-white p-6 rounded-2xl shadow-sm border border-gray-100">
          <h3 class="text-gray-500 text-sm font-medium mb-2">Saved Content</h3>
          <p class="text-3xl font-bold text-gray-900">0</p>
        </div>
        <div class="bg-white p-6 rounded-2xl shadow-sm border border-gray-100">
          <h3 class="text-gray-500 text-sm font-medium mb-2">Upcoming Sessions</h3>
          <p class="text-3xl font-bold text-gray-900">0</p>
        </div>
      </div>

      <div class="bg-white rounded-2xl shadow-sm border border-gray-100 p-6">
        <h2 class="text-lg font-bold text-gray-900 mb-4">Recent Activity</h2>
        <div class="text-center py-12 text-gray-400">
          <span class="material-symbols-outlined text-4xl mb-3">history</span>
          <p>No recent activity</p>
          <a href="/content" class="inline-block mt-4 text-blue-600 font-medium hover:underline">
            Browse Content
          </a>
        </div>
      </div>
    </div>
  </DashboardLayout>
</template>
